// combatpro/treasure/treasureMonster.js
//
// Derive a generation context from a LIVE combat monster instance. The in-combat
// monster model has no explicit creature-type field, so we infer creature tags from
// its stated fields (selectedMonster / customName / race / class / size) via a small
// keyword map, and the level from CR. This keeps generation monster-aware using real
// attributes without inventing data. No DOM, no optional chaining, no em dash.

// keyword -> creatureType tag. First match wins (checked in this order).
var KEYWORD_TYPE = [
  ['dragon', 'dragon'], ['wyrm', 'dragon'], ['drake', 'dragon'], ['wyvern', 'dragon'],
  ['skeleton', 'undead'], ['zombie', 'undead'], ['ghost', 'undead'], ['wraith', 'undead'],
  ['lich', 'undead'], ['undead', 'undead'], ['vampire', 'undead'], ['ghoul', 'undead'], ['specter', 'undead'], ['spectre', 'undead'], ['wight', 'undead'], ['mummy', 'undead'],
  ['golem', 'construct'], ['construct', 'construct'], ['automaton', 'construct'], ['animated', 'construct'], ['clockwork', 'construct'],
  ['demon', 'fiend'], ['devil', 'fiend'], ['fiend', 'fiend'], ['imp', 'fiend'], ['hell', 'fiend'],
  ['angel', 'celestial'], ['celestial', 'celestial'], ['deva', 'celestial'],
  ['elemental', 'elemental'], ['fey', 'fey'], ['sprite', 'fey'], ['pixie', 'fey'], ['dryad', 'fey'],
  ['giant', 'giant'], ['ogre', 'giant'], ['troll', 'giant'], ['ooze', 'ooze'], ['slime', 'ooze'], ['pudding', 'ooze'],
  ['aberration', 'aberration'], ['beholder', 'aberration'], ['mind flayer', 'aberration'], ['illithid', 'aberration'],
  ['plant', 'plant'], ['shambling', 'plant'], ['treant', 'plant'],
  ['wolf', 'beast'], ['bear', 'beast'], ['boar', 'beast'], ['spider', 'beast'], ['rat', 'beast'], ['snake', 'beast'], ['beast', 'beast'], ['tiger', 'beast'], ['lion', 'beast'], ['ape', 'beast'], ['hound', 'beast'], ['bat', 'beast'], ['shark', 'beast'], ['eagle', 'beast'],
  ['monstrosity', 'monstrosity'], ['chimera', 'monstrosity'], ['manticore', 'monstrosity'], ['griffon', 'monstrosity'], ['hydra', 'monstrosity'],
  ['orc', 'humanoid'], ['goblin', 'humanoid'], ['kobold', 'humanoid'], ['bandit', 'humanoid'], ['guard', 'humanoid'], ['cultist', 'humanoid'], ['knight', 'humanoid'], ['soldier', 'humanoid'], ['mage', 'humanoid'], ['priest', 'humanoid'], ['human', 'humanoid'], ['elf', 'humanoid'], ['dwarf', 'humanoid'], ['gnoll', 'humanoid'], ['hobgoblin', 'humanoid'], ['drow', 'humanoid'], ['pirate', 'humanoid'], ['thug', 'humanoid'], ['captain', 'humanoid']
];

function crToLevel(cr) {
  if (cr === undefined || cr === null || cr === '') { return 1; }
  var str = String(cr).trim();
  if (str.indexOf('/') !== -1) { return 1; } // fractional CR -> level 1
  var n = parseFloat(str);
  if (isNaN(n)) { return 1; }
  return Math.max(1, Math.min(40, Math.round(n)));
}

export function deriveMonsterContext(monster) {
  var m = monster || {};
  var hay = [m.selectedMonster, m.customName, m.race, m.class, m.type].filter(function (x) { return x; }).join(' ').toLowerCase();
  var tag = '';
  for (var i = 0; i < KEYWORD_TYPE.length; i++) {
    if (hay.indexOf(KEYWORD_TYPE[i][0]) !== -1) { tag = KEYWORD_TYPE[i][1]; break; }
  }
  if (!tag) { tag = 'humanoid'; } // sensible default: a named combatant with gear
  var name = (m.customName && m.customName.trim()) ? m.customName.trim() : (m.selectedMonster || 'Monster');
  return {
    creatureTags: [tag],
    creatureType: tag,
    level: crToLevel(m.cr),
    name: name
  };
}
